import { decimalToCents, parseMoneyInput } from '@/shared/format/money';
import type { CivilDate } from '@/shared/format/date';
import { documentInputRaw, maskDocumentInput } from '@/shared/format/document';

/** Início do dia em São Paulo, como `formatInitialDateWithTimeZone` do legado (`DateFormat.ts:299`). */
export function startOfDayParam(day: CivilDate): string {
  return `${day}T00:00:00-03:00`;
}

/** Fim do dia em São Paulo, como `formatFinalDateWithTimeZone` do legado (`DateFormat.ts:306`). */
export function endOfDayParam(day: CivilDate): string {
  return `${day}T23:59:59.999999-03:00`;
}

/** Só letras e dígitos, em maiúsculas (CNPJ alfanumérico), até 14. */
export function documentRaw(value: string): string {
  return documentInputRaw(value);
}

/**
 * Máscara progressiva do campo CPF/CNPJ do filtro do legado: CPF até 11 caracteres, CNPJ acima disso
 * ou com letra.
 */
export function maskDocumentProgressive(value: string): string {
  return maskDocumentInput(documentRaw(value));
}

/** Texto em reais para centavos; vazio/inválido segue ausente (filterContext do legado). */
export function moneyCentsParam(value: string): number | undefined {
  const decimal = parseMoneyInput(value);
  return decimal === null ? undefined : decimalToCents(decimal);
}
/** Meia-noite de São Paulo em UTC, como new Date(DatePicker).toISOString() do legado. */
export function midnightIsoParam(day: CivilDate): string {
  return new Date(`${day}T00:00:00.000-03:00`).toISOString();
}
